let cartSideloaded = false;
document.addEventListener("DOMContentLoaded", function () {
  if (!cartSideloaded) {
    // const cartSideFooter = document.querySelector("#CartContainer");
    // addSideMutationObserver(cartSideFooter, triggerSideTermsTranslate);
    // // cartSideloaded = true;

    const isCartVisible = document.querySelector(
      '[data-section-type="cart-drawer"]'
    );

    if (isCartVisible) {
      addCheckboxTermsListener(
        "input[name=checkout]",
        "click",
        checkTermsCheckbox
      );
      addCheckboxTermsListener(
        '[data-role="cart-terms-checkbox"]',
        "click",
        logUserCheck
      );
    }
  }
});

isNotifyReady = false;

function addSideMutationObserver(targetNode, customCallback) {
  // console.log("Observer | addMutationObserver 2");
  // console.log(targetNode);
  if (targetNode) {
    console.log("Observer | target on node");
    let config = { attributes: true, childList: true, subtree: true };
    const callback = function (mutationsList, observer) {
      // console.log("Observer | callback called");
      // isNotifyReady = false;
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        // console.log(mutation);
        if (mutation.type === "childList" && !cartSideloaded) {
          if (isNotifyReady == false) {
            customCallback();
          }
        }
      }
    };

    let observer = null;
    observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}

// const isCheckApp = (nodes) => {
// 	const nodeChildren = Array.from(nodes).map((node) => {
// 		return Array.from(node.children).map((child) => {
// 			console.log(child);

// 		});
// 	});
// 	console.log(nodeChildren);
// 	return nodeChildren;
// };

function triggerSideTermsTranslate() {
  const check = document.querySelector(".cart-drawer__submit > p > label");
  // console.log("CHECK");
  // console.log(check);
  if (check) {
    check.innerHTML = `${cartTranslations.termsConditionsPrefix} <a class='underline' target="_blank" href='/pages/terms-conditions'>${cartTranslations.termsConditionsSuffix} </a>`;
    cartSideloaded = true;
  }
}

const addCheckboxTermsListener = (selector, event, handler) => {
  let rootElement = document.querySelector('[data-section-type="cart-drawer"]');
  rootElement.addEventListener(
    event,
    function (evt) {
      var targetElement = evt.target;
      while (targetElement != null) {
        if (targetElement.matches(selector)) {
          handler(evt);
          return;
        }
        targetElement = targetElement.parentElement;
      }
    },
    true
  );
};

const checkTermsCheckbox = (e) => {
  const checkoutForm = e.target.closest("form");
  const termsInput = checkoutForm.querySelector("#terms-check");

  if (!termsInput.checked) {
    alert(window.theme.strings.termsNotify);
    e.preventDefault();
    return;
  }
};

const logUserCheck = (e) => {
  const checkoutForm = e.target.closest("form");
  const termsInput = checkoutForm.querySelector("#terms-check");

  const termsRecordInput = checkoutForm.querySelector(
    "#agreed-to-the-terms-and-conditions-on"
  );
  termsRecordInput.value = termsInput.checked ? new Date() : "";
};
